"use strict";

import React from "react";
import ReactDOM from "react-dom";


class Utils extends React.Component {
    static getMonthYear(monthCount) {

		if (monthCount === 0) {
			return "0 mo";
		}

		function getPlural(number, word) {
            return number === 1 && word.one || word.other;
        }

        var months = { one: 'mo', other: 'mos' },
            years = { one: 'yr', other: 'yrs' },
            m = monthCount % 12,
            y = Math.floor(monthCount / 12),
            result = [];

        y && result.push(y + ' ' + getPlural(y, years));
        m && result.push(m + ' ' + getPlural(m, months));
        return result.join(' ');
	}

	static getMonthYearNoAbbr(monthCount) {

		if (monthCount === 0) {
			return "0 mo";
		}

		function getPlural(number, word) {
			return number === 1 && word.one || word.other;
		}

		var months = { one: 'month', other: 'months' },
			years = { one: 'year', other: 'years' },
			m = monthCount % 12,
			y = Math.floor(monthCount / 12),
			result = [];

		y && result.push(y + ' ' + getPlural(y, years));
		m && result.push(m + ' ' + getPlural(m, months));
		return result.join(' ');
	}

    static formatCurrencyRange(value, isCurrency) {

        var currencySymbol = isCurrency ? '$' : '';
        
        if (value < 1000) {
            return currencySymbol + value.toString();
        }

        if (value < 1000000) {
            var thousands = Math.round(Math.round(value / 100) / 10);
            return currencySymbol + thousands.toString() + 'K';
        }

        var millions = (Math.round(value / 10000) / 100).toFixed(1);
        return currencySymbol + millions.toString() + 'M';
        
    };

    static formatDisplayRange(value, type) {
        if (type == "daterange") {
            return this.getMonthYear(value);
        } else if(type == "number") {
            return this.formatCurrencyRange(value, false);
        } 

        return this.formatCurrencyRange(value, true);
        

        
    }

    static formatDisplayValue(value, type, abbr=true) {

		if (type == "daterange") {
			if (abbr)
				return this.getMonthYear(value);
			else
				return this.getMonthYearNoAbbr(value);
        }

		var isNegative = value < 0;

        value = Math.abs(value).toString();

        var i = value.length - 3;
        while (i > 0) {
            value = value.substring(0, i) + ',' + value.substring(i);
            i = i - 3;
        }
		return isNegative ? '($' + value + ')' : '$' + value;
    }
}

export default Utils;

/****  POLYFILL FOR Object.assign ******/
if (typeof Object.assign != 'function') {
	// Must be writable: true, enumerable: false, configurable: true
	Object.defineProperty(Object, "assign", {
		value: function assign(target, varArgs) { // .length of function is 2
			'use strict';
			if (target == null) { // TypeError if undefined or null
				throw new TypeError('Cannot convert undefined or null to object');
			}

			var to = Object(target);

			for (var index = 1; index < arguments.length; index++) {
				var nextSource = arguments[index];

				if (nextSource != null) { // Skip over if undefined or null
					for (var nextKey in nextSource) {
						// Avoid bugs when hasOwnProperty is shadowed
						if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
							to[nextKey] = nextSource[nextKey];
						}
					}
				}
			}
			return to;
		},
		writable: true,
		configurable: true
	});
}